/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Navigate } from 'react-router-dom';
import DefaultLayout from 'layouts/DefaultLayout';
import { storage } from 'helpers';
// eslint-disable-next-line import/named
import { NotFound } from '../../views/index';

const PrivateRoute = ({ component: Component, authorityCode, ...rest }) => {
  const token = storage.getToken();
  const currentUser = storage.getUserInfo();

  if (!token) {
    return <Navigate to="/login" replace state={{ from: rest.location }} />;
  }

  const userAuthorities = currentUser?.role?.authorities;
  const index = userAuthorities.findIndex((auth) => auth.code === authorityCode);

  if (index !== -1) {
    return (
      <DefaultLayout>
        <Component {...rest} />
      </DefaultLayout>
    );
  }

  // Eğer kullanıcı yetkili değilse, 403 durumuna yönlendirme
  // return <Navigate to="/dashboard" replace state={{ status: 403 }} />;

  return (
    <DefaultLayout>
      <NotFound />
    </DefaultLayout>
  );
};


export default PrivateRoute;
